import { withMutation } from '../../../../HOC/common';
import * as gazetteerService from 'services/gazetters';

/**
 * @param {Function} mutateAsync - function to trigger the mutation
 * @param {object} mutationResult - full result object from useMutation, containing isLoading, etc
 * @returns {object} props to be passed to the wrapped component
 */
const mapMutationToProps = (mutateAsync, { isLoading }) => ({
    saveMutation: mutateAsync,
    isSaving: isLoading,
});

/**
 * a hoc that provides gazetteer save functionality to a component
 */
export const withGazettersSave = withMutation({
    mutationFn: gazetteerService.saveGazettersNew,
    mapMutationToProps,
});



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/HOC.jsx